import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import dragIcon from "../../../assets/images/icn_drag.svg";
import closeIcon from "../../../assets/images/close.svg";
import dummyImageIcon from "../../../assets/images/icn_dummy_image.svg";
import { Col, Row } from "reactstrap";
import "./SortableList.scss";
import { ISortableList } from "../../../interfaces/Index";

export const onSortEnd = (indexes: any, props: ISortableList) => {
  let assignCategoryProductState = arrayMove(
    props.categoryProducts,
    indexes.oldIndex,
    indexes.newIndex
  );
  props.handleProductSortEnd(assignCategoryProductState);
};

const SortableComponent: React.FC<ISortableList> = (props: ISortableList) => {
  const SortableItem = SortableElement(({ value, index }: any) => (
    <li>
      <Row>
        <Col lg="1" className="drag-icon">
          <img src={dragIcon} alt="drag" />
        </Col>
        <Col lg="2" className="product-image">
          <img
            src={value.imageUrl ? value.imageUrl : dummyImageIcon}
            alt="item"
          />
        </Col>
        <Col lg={props.isCross ? "7" : "9"} className="product-name">
          {value.title}
        </Col>
        {props.isCross && (
          <Col lg="2" className="close-container">
            <img
              src={closeIcon}
              alt="close"
              onClick={(e) => {
                e.stopPropagation();
                if (props.crossHandler) {
                  props.crossHandler(index);
                }
              }}
            />
          </Col>
        )}
      </Row>
    </li>
  ));

  const SortableList = SortableContainer(({ items }: any) => {
    return (
      <ul className="sequence-sorting-container">
        {items.map((value: string, index: number) => (
          <SortableItem key={index} index={index} value={value} />
        ))}
      </ul>
    );
  });

  return (
    <SortableList
      items={props.categoryProducts}
      onSortEnd={(indexes: any) => {
        onSortEnd(indexes, props);
      }}
      distance={props.distance}
    />
  );
};

SortableComponent.defaultProps = {
  crossHandler: () => {},
  distance: 0, // Distance is set so that a child click handler can be invoked, other-wise drag functionality does not allow it
};

export default SortableComponent;
